import {keys} from "../config/nameSpacesKeys";
import GenericLangValue from "./GenericLangValue";
import HasBenchmark from "./HasBenchmark";
import {assetKeys} from "../config/constants";

export default class EvaluationObj {
  constructor(name, initialValue, namespace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.isEditor = isEditor;
    this.evaluationOutput = new GenericLangValue(name = "evaluationOutput", null, keys.evaluationOutput);
    this.metric = new GenericLangValue(name = "metric", null, keys.metric);
    this.task = new GenericLangValue(name = "task", null, keys.task);
    this.hasBenchmarkList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyHasBenchmarkObj();
    }
  }

  getObjList() {
    return this.hasBenchmarkList;
  }

  getNameSpace() {
    return this.namespace;
  }

  getEvaluationOutput() {
    return this.evaluationOutput;
  }

  setEvaluationOutput(evaluationOutputObj) {
    this.evaluationOutput = evaluationOutputObj;
  }

  getMetric() {
    return this.metric;
  }

  setMetric(metricObj) {
    this.metric = metricObj;
  }

  getTask() {
    return this.task;
  }

  setTask(taskObj) {
    this.task = taskObj;
  }

  createEmptyHasBenchmarkObj() {
    const hasBenchmark = new HasBenchmark("hasBenchmark", null, keys.hasBenchmark, this.isEditor);
    this.hasBenchmarkList.push(hasBenchmark);
  }

  createHasBenchmarkObj(obj) {
    const hasBenchmark = new HasBenchmark("hasBenchmark", obj, keys.hasBenchmark, this.isEditor);
    // hasBenchmark.parseInputJSON(obj);
    this.hasBenchmarkList.push(hasBenchmark);
  }

  removeHasBenchmarkObj(obj, index) {
    if (index < 0 || index >= this.hasBenchmarkList.length) {
      return false;
    }
    this.hasBenchmarkList.splice(index, 1);
  }

  setHasBenchmark(inputObj) {
    const hasBenchmarkObj = inputObj[keys.hasBenchmark];
    if (Array.isArray(hasBenchmarkObj)) {
      for (const entry of Object.entries(hasBenchmarkObj)) {
        const value = entry[1];
        this.createHasBenchmarkObj(value);
      }
    } else {
      this.createHasBenchmarkObj(hasBenchmarkObj);
    }
  }

  setValueObj(obj) {
    // console.log(obj);
    this.task.parseInputJSON(obj);
    this.metric.parseInputJSON(obj);
    this.evaluationOutput.parseInputJSON(obj);
    this.setHasBenchmark(obj);
  }

  parseInputJSON(inputJSON) {
    const obj=inputJSON;
    // console.log(obj);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.parseObj(value);
      }
    } else {
      this.parseObj(obj);
    }
  }

  parseObj(obj) {
    this.task.parseInputJSON(obj);
    this.metric.parseInputJSON(obj);
    this.evaluationOutput.parseInputJSON(obj);
    this.setHasBenchmark(obj);
  }


  getExpandedFormatValue() {
    const obj = {};
    obj[assetKeys.type] = [`${keys.evaluationType}`];
    const evaluationOutputExpanded = this.evaluationOutput.getExpandedFormatValue();
    const metricExpanded = this.metric.getExpandedFormatValue();
    const taskExpanded = this.task.getExpandedFormatValue();
    obj[this.evaluationOutput.getNameSpace()] = evaluationOutputExpanded;
    obj[this.metric.getNameSpace()] = metricExpanded;
    obj[this.task.getNameSpace()] = taskExpanded;

    const hasBenchmarkExpanded = [];
    for (let index = 0; index < this.hasBenchmarkList.length; index++) {
      const item = this.hasBenchmarkList[index];
      hasBenchmarkExpanded.push(item.getExpandedFormatValue());
    }
    obj[keys.hasBenchmark] = hasBenchmarkExpanded;

    return obj;
  }

  isEmpty() {
    const condition1 = this.evaluationOutput.isEmpty();
    const condition2 = this.metric.isEmpty();
    const condition3 = this.task.isEmpty();
    let condition4 = true;
    for (let index = 0; index < this.hasBenchmarkList.length; index++) {
      const listItem = this.hasBenchmarkList[index];
      condition4 = condition4 && listItem.isEmpty();
    }
    return condition1 && condition2 && condition3 && condition4;
  }
}
